import React from 'react';

import { Stack } from '@mui/material';

import type { SpendPointsPayloadBuilderState } from '~/utils/societePayloadBuilder/spendPoints/types';

import { PAYLOAD_BUILDER_REQUIRED_FIELDS_SX } from '../FieldLabels';
import LoadPayloadSection from '../LoadPayloadSection';

import SpendPointsTilesSection from './SpendPointsTilesSection';

interface SpendPointsPayloadBuilderFormProps {
  collapseResetKey: number;
  state: SpendPointsPayloadBuilderState;
  onChange: (next: SpendPointsPayloadBuilderState) => void;
  loadJson: string;
  onLoadJsonChange: (value: string) => void;
  loadError: string | null;
  loadCollapseKey?: number;
  onLoadPayload: () => void;
  onClearLoad: () => void;
  onUploadFile: (file: File) => void;
}

export default function SpendPointsPayloadBuilderForm({
  collapseResetKey,
  state,
  onChange,
  loadJson,
  onLoadJsonChange,
  loadError,
  loadCollapseKey,
  onLoadPayload,
  onClearLoad,
  onUploadFile,
}: SpendPointsPayloadBuilderFormProps) {
  return (
    <Stack spacing={2}>
      <LoadPayloadSection
        loadJson={loadJson}
        loadError={loadError}
        collapseKey={loadCollapseKey}
        onLoadJsonChange={onLoadJsonChange}
        onLoadPayload={onLoadPayload}
        onClearLoad={onClearLoad}
        onUploadFile={onUploadFile}
      />

      <Stack key={collapseResetKey} sx={PAYLOAD_BUILDER_REQUIRED_FIELDS_SX}>
        <SpendPointsTilesSection
          tiles={state.waysToBoostTiles}
          onChange={(waysToBoostTiles) => onChange({ ...state, waysToBoostTiles })}
        />
      </Stack>
    </Stack>
  );
}
